function parse_disposal_route(route) {
  const route_parts = route.replace(/^Approval route:\s*/i, '').split(' - ');
  const disposal_route = {
    approval_route: Reflect.get(route_parts, 0) || '',
    note: route_parts.slice(1).join(' - ') || route
  };
  return disposal_route;
}

function parse_salvage_value(subtitle) {
  if (!subtitle.includes('R ')) return '0';
  const salvage_value = (subtitle.match(/R\s?([\d\s]+)/)?.[1] || '').replace(/\s/g, '');
  return salvage_value;
}

function resolve_disposal_stage(row) {
  const stage_index = Math.max(0, (row.active_stage || 1) - 1);
  const disposal_stage = Reflect.get(row.stages, stage_index) || 'Identified';
  return disposal_stage;
}

export function build_disposal_form_state(row) {
  const route_details = parse_disposal_route(row.route);
  const salvage_value = parse_salvage_value(row.subtitle);
  const subtitle_parts = row.subtitle.split(' - ');
  const reason = Reflect.get(subtitle_parts, 0) || row.subtitle;
  const method = subtitle_parts.slice(1).join(' - ') || '';
  const disposal_form_state = {
    ref: row.ref,
    asset: `${row.ref} - ${row.asset}`,
    reason,
    method,
    salvage_value,
    approval_route: route_details.approval_route,
    stage: resolve_disposal_stage(row),
    status: row.status.label,
    note: route_details.note
  };
  return disposal_form_state;
}
